import Quill from 'quill';
import * as Constants from "../../../../utils/constants";
import { format as formatDate } from "date-fns";

let Parchment = Quill.import('parchment');
const config = {
    scope: Parchment.Scope.BLOCK,
}
let LineHeightClass = new Parchment.Attributor.Class('lineheight', 'ql-line-height', config);
let LineHeightStyle = new Parchment.Attributor.Style('lineheight', 'line-height', config);
Parchment.register(LineHeightClass);
Parchment.register(LineHeightStyle);

let fsStyle = new Parchment.Attributor.Style(Constants.quillFormatKeywords.fontSize, 'font-size', {
    scope: Parchment.Scope.INLINE
});
Quill.register(fsStyle);


let ffStyle = new Parchment.Attributor.Style(Constants.quillFormatKeywords.fontfamily, 'font-family', {
    scope: Parchment.Scope.INLINE
});
Parchment.register(ffStyle);

let colorStyle = new Parchment.Attributor.Style(Constants.quillFormatKeywords.color, 'color', {
    scope: Parchment.Scope.INLINE
});
Parchment.register(colorStyle);

let bgColorStyle = new Parchment.Attributor.Style(Constants.quillFormatKeywords.bgColor, 'background-color', {
    scope: Parchment.Scope.INLINE
});
Parchment.register(bgColorStyle);

let alignStyle = new Parchment.Attributor.Style(Constants.quillFormatKeywords.align, 'text-align', {
    whitelist: [
        Constants.quillFormatKeywords.alignLeft,
        Constants.quillFormatKeywords.alignRight,
        Constants.quillFormatKeywords.alignCenter,
        Constants.quillFormatKeywords.alignJustify]
});
Parchment.register(alignStyle);

let textIndentStyle = new Parchment.Attributor.Style(Constants.quillFormatKeywords.textIndent, 'text-indent', {
    scope: Parchment.Scope.BLOCK
});
Parchment.register(textIndentStyle);

let paddingleftStyle = new Parchment.Attributor.Style(Constants.quillFormatKeywords.paddingleft, 'padding-left', {
    scope: Parchment.Scope.BLOCK
});
Parchment.register(paddingleftStyle);

let paddingrightStyle = new Parchment.Attributor.Style(Constants.quillFormatKeywords.paddingright, 'padding-right', {
    scope: Parchment.Scope.BLOCK
});
Parchment.register(paddingrightStyle);

let paddingtopStyle = new Parchment.Attributor.Style(Constants.quillFormatKeywords.paddingtop, 'padding-top', {
    scope: Parchment.Scope.BLOCK
});
Parchment.register(paddingtopStyle);

let paddingbottomStyle = new Parchment.Attributor.Style(Constants.quillFormatKeywords.paddingbottom, 'padding-bottom', {
    scope: Parchment.Scope.BLOCK
});
Parchment.register(paddingbottomStyle);

let marginleftStyle = new Parchment.Attributor.Style(Constants.quillFormatKeywords.margnleft, 'margin-left', {
    scope: Parchment.Scope.BLOCK
});
Parchment.register(marginleftStyle);

// register custom attribute 'auto-date-field' for autoDate component
let autoDateAttribute = new Parchment.Attributor.Attribute(Constants.autoDate.htmlAttribute, Constants.autoDate.htmlAttribute, {
    scope: Parchment.Scope.INLINE
});
Parchment.register(autoDateAttribute);

// create readonly autoDate embed blot and register it
class AutoDateBlob extends Parchment.Embed {
    static create(value) {
        let autoDateFormat = '';
        if (typeof value === 'string') {
            autoDateFormat = value;
        } else if ((typeof value === 'object') && value.hasOwnProperty(Constants.autoDate.htmlAttribute) && (typeof value[Constants.autoDate.htmlAttribute] === 'string')) {
            autoDateFormat = value[Constants.autoDate.htmlAttribute];
        }

        const node = super.create();
        node.contentEditable = 'false';
        node.setAttribute(Constants.autoDate.htmlAttribute, autoDateFormat)

        try {
            const now = new Date();
            node.innerText = now.toISOString().split('T')[0];

            if (autoDateFormat) {
                node.innerText = formatDate(now, autoDateFormat);
            }
        } catch (err) {
            // invalid format or can not format date
        }

        return node;
    }

    static value(node) {
        let ret = {};
        if (node.hasAttributes()) {
            for (const attr of node.attributes) {
                ret[attr.name] = attr.value;
            }
        }
        return ret;
    }
}
AutoDateBlob.blotName = Constants.autoDate.quillEmbedBlotName;
AutoDateBlob.tagName = Constants.autoDate.quillEmbedTagName;
AutoDateBlob.className = Constants.autoDate.quillEmbedClassName;
Quill.register(AutoDateBlob);

export default Quill;
